<template>
  <div class="d-flex my-md-4 flex-column justify-content-between align-items-center">
    <div class="w-100">
      <div class="d-md-flex justify-content-md-between align-items-md-baseline">
        <h1 tabindex="-1" ref="focusFirst"><slot name="title" /></h1>
        <slot name="title-right" />
      </div>
      <p>
        <slot name="subheading" />
      </p>
    </div>
    <div class="wc-single-page-form__body">
      <slot name="body" />
    </div>
  </div>
</template>

<script>
import FocusMixin from '@/mixins/FocusMixin';

export default {
  name: 'WCSinglePageForm',
  mixins: [FocusMixin], // Mixin for main content focus via routing
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/_tools.scss';
@import '~@/assets/styles/_settings.scss';

.wc-single-page-form__body {
  width: 100%;
}

@include media-breakpoint-up(md) {
  .wc-single-page-form__body {
    width: 65%;
  }
}
</style>
